import { type ImageElement } from '@@editor/helpers/Element';

const getElvisIdByImage = (element: Partial<ImageElement>) =>
    element ? element.data?.embed?.elvisId : null;

export default getElvisIdByImage;
